<template>
  <card>
    <list
      v-if="$store.state.user.sections['orders']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :setImport="true"
      :exportFields="exportFields"
      :isAdd="false"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        Дата: {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        Заказ: {
          field: "model",
          callback: (val) => {
            try {
              return val.id;
            } catch (error) {
              return "";
            }
          },
        },
        "Торговая точка": {
          field: "model",
          callback: (val) => {
            try {
              return val.shop.name;
            } catch (error) {
              return "";
            }
          },
        },
        "Отвественный заказа": {
          field: "model",
          callback: (val) => {
            try {
              return val.user.name;
            } catch (error) {
              return "";
            }
          },
        },
        Действие: {
          field: "user.name",
          callback: (value) => {
            return value;
          },
        },
        Название: "name",
        Примечание: "description",
        Запрос: "request",
        Ответ: "response",
        Заголовок: "headers",
        Ссылка: "url",
        Версия: "version",
        IP: "ip",
      },
      staticFilters: [],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "user",
          title: "Фильтр по сотрудникам",
          titleKey: "user",
          field_key: "user",
          selectKey: "name",
        },
        {
          key: "order",
          title: "Фильтр по заказам",
          titleKey: "order",
          field_key: "model",
          selectKey: "id",
        },
        {
          key: "status",
          title: "Фильтр по статусам",
          titleKey: "status_filter",
          field_key: "status",
          selectKey: "name",
        },
        {
          key: "partner",
          title: "Фильтр по партнерам",
          titleKey: "partner_filter",
          field_key: "partner",
          selectKey: "name",
        },
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "shop_filter",
          field_key: "shop",
          selectKey: "name",
        },
        {
          key: "client",
          title: "Фильтр по покупателям",
          titleKey: "client_filter",
          field_key: "client",
          selectKey: "phone",
        },
        {
          key: "organization",
          title: "Фильтр по организациям",
          titleKey: "organization_filter",
          field_key: "organization",
          selectKey: "name",
        },
      ],
      params: {
        order: true,
      },
      val: [],
      modalCreate: "business",
      fields: [
        {
          label: "Номер телефона",
          key: "phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_log",
      itemLink: "logs",
      setLink: "logs",
      columns: [
        {
          key: "model",
          keyAs: "order",
          title: "Номер заказа",
          object: "id",
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "user",
          title: "Сотрудник",
          object: "phone",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "name",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "description",
          title: "Примечание",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "ip",
          title: "IP",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "version",
          title: "V.",
        },

        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
